/* eslint-disable @next/next/no-img-element */
import type { ImgHTMLAttributes } from 'react';

type NextImageShimProps = ImgHTMLAttributes<HTMLImageElement> & {
  fill?: boolean;
  priority?: boolean;
  unoptimized?: boolean;
};

export default function Image({
  alt = '',
  fill,
  height,
  priority: _priority,
  unoptimized: _unoptimized,
  width,
  style,
  ...props
}: NextImageShimProps) {
  const fillStyle = fill
    ? {
        position: 'absolute' as const,
        inset: 0,
        height: '100%',
        width: '100%',
      }
    : undefined;

  return (
    <img
      {...props}
      alt={alt}
      height={fill ? undefined : height}
      style={{ ...fillStyle, ...style }}
      width={fill ? undefined : width}
    />
  );
}
